import { render } from "./Invitation.vue?vue&type=template&id=034fbd5a&scoped=true"
import script from "./Invitation.vue?vue&type=script&lang=ts"
export * from "./Invitation.vue?vue&type=script&lang=ts"

import "./Invitation.vue?vue&type=style&index=0&id=034fbd5a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-034fbd5a"

export default script